import React, { useEffect } from 'react';

// Helper component to enhance keyboard navigation
const KeyboardAccessibilityHelper = () => {
  useEffect(() => {
    const handleGlobalKeyDown = (e) => {
      // Add keyboard shortcuts for common actions
      if (e.ctrlKey || e.metaKey) {
        switch (e.key) {
          case 'k':
            // Focus search if available
            e.preventDefault();
            const searchInput = document.querySelector('[aria-label*="search" i], [placeholder*="search" i]');
            if (searchInput) {
              searchInput.focus();
            }
            break;
          case 'n':
            // New chat shortcut
            e.preventDefault();
            const newChatButton = document.querySelector('[aria-label*="new chat" i]');
            if (newChatButton) {
              newChatButton.click();
            }
            break;
          default:
            break;
        }
      }

      // ESC key to close modals/dropdowns
      if (e.key === 'Escape') {
        const modal = document.querySelector('[role="dialog"]:not([aria-hidden="true"])');
        if (modal) {
          const closeButton = modal.querySelector('[aria-label*="close" i]');
          if (closeButton) {
            closeButton.click();
          }
        }
      }
    };

    document.addEventListener('keydown', handleGlobalKeyDown);
    return () => document.removeEventListener('keydown', handleGlobalKeyDown);
  }, []);

  return null; // This component doesn't render anything
};

export default KeyboardAccessibilityHelper; 